import type { Components } from '@mui/material/styles';

import type { Theme } from '../types';

export const MuiMenu = {
  defaultProps: { disableScrollLock: true },
  styleOverrides: {
    list: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
      padding: '6px',
    },
    paper: ({ theme }) => ({
      border: '1px solid var(--mui-palette-divider)',
      borderRadius: '12px',
      boxShadow: theme.shadows[4],
    }),
  },
} satisfies Components<Theme>['MuiMenu'];
